import React, {
  useCallback,
} from 'react';
import { FieldRenderProps } from 'react-final-form';
import { TextAreaInputProps } from './types';
import './TextAreaInput.scss';

const TextInput: React.FC<
  | TextAreaInputProps
  | FieldRenderProps<any, HTMLInputElement | HTMLTextAreaElement> 
> = (props) => {
  const {
    id,
    input,
    placeholder,
    onChange,
    value,
    readOnly,
    disabled,
    testId,
    maxLength,
    pattern
  } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const value = e.target.value;
      const patt = new RegExp(pattern);
      const isOneCharShorter = value.length === input.value.length - 1;
      const isAlmostEqual =
        isOneCharShorter && input.value.indexOf(value) === 0;
      if ((!value || patt.test(value) || isAlmostEqual)) {
        if (input) {
          input.onChange(value);
        }
        if (onChange) {
          onChange(value);
        }
      }
    },
    [input, pattern, onChange],
  );

  return (
    <div
      id={id}
      className="input-container"
      data-testid={testId}
    >
      <textarea
        {...input}
        id={id + "-input"}
        readOnly={readOnly || disabled}
        disabled={disabled}
        value={input ? input.value : value}
        maxLength={maxLength}
        onChange={handleChange}
        placeholder={placeholder}
        data-testid="textarea-input-id"
      />
    </div>
  );
};

export default TextInput;
